module.exports = __webpack_public_path__ + "static/media/grad.e8979578.jpg";